import { Directive } from '@angular/core';
import {
  AbstractControlOptions,
  FormArray,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class EaBudgetFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    const budgets = Array.isArray(entity) ? entity : [];
    const options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        budgets: this.formBuilder.array(
          budgets.map(budget => this.createBudgetFormGroup(budget)),
        ),
      },
      options,
    );
  }

  createBudgetFormGroup(budget?: any): FormGroup {
    return this.formBuilder.group({
      id: [budget ? budget.id : null],
      accountId: [budget?.accountId, Validators.required],
      budgetType: [
        budget && budget.budgetType ? budget.budgetType : 'EXPENSE',
        Validators.required,
      ],
      frequency: [
        budget && budget.frequency ? budget.frequency : 'MENS',
        Validators.required,
      ],
      category: [budget ? budget.category : null, Validators.required],
      type: [budget ? budget.type : null, Validators.required],
      label: [budget ? budget.label : null],
      amount: [budget ? budget.amount : null, Validators.required],
      automatic: [budget ? budget.automatic : false],
    });
  }

  get budgetsArray(): FormArray {
    return this.form.get('budgets') as FormArray;
  }

  extract() {
    const budgets = this.budgetsArray.value
      .filter((budget: any) => !budget.automatic)
      .map((budget: any) => ({
        id: this.emptyIsNull(budget.id),
        accountId: budget.accountId,
        budgetType: budget.budgetType,
        frequency: budget.frequency,
        category: this.emptyIsNull(budget.category),
        type: this.emptyIsNull(budget.type),
        label: this.emptyIsNull(budget.label),
        amount: this.parseFloat(budget.amount),
        automatic: budget.automatic || false,
      }));
    return budgets;
  }
}
